import React from 'react';
import PropTypes from 'prop-types';
import { efesGrayish } from '../../../theme';

const Linkedin = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28.672 28.672">
    <path
      d="M4.424,24.005H8.736V11.051H4.424ZM9.016,7.056a2.206,2.206,0,0,0-.672-1.605,2.385,2.385,0,0,0-1.736-.635,2.485,2.485,0,0,0-1.764.635,2.1,2.1,0,0,0-.681,1.605,2.136,2.136,0,0,0,.663,1.6A2.373,2.373,0,0,0,6.552,9.3h.019a2.456,2.456,0,0,0,1.773-.644A2.122,2.122,0,0,0,9.016,7.056Zm10.92,16.949h4.312V16.576a6.2,6.2,0,0,0-1.363-4.349,4.672,4.672,0,0,0-3.6-1.475,4.34,4.34,0,0,0-3.9,2.184h.037V11.051H11.107q.056,1.232,0,12.955h4.312V16.763a3.088,3.088,0,0,1,.131-1.045,2.881,2.881,0,0,1,.84-1.111,2.112,2.112,0,0,1,1.381-.457q2.165,0,2.165,2.931ZM28.672,5.376V23.3A5.385,5.385,0,0,1,23.3,28.672H5.376a5.178,5.178,0,0,1-3.8-1.577A5.178,5.178,0,0,1,0,23.3V5.376a5.178,5.178,0,0,1,1.577-3.8A5.178,5.178,0,0,1,5.376,0H23.3a5.178,5.178,0,0,1,3.8,1.577A5.178,5.178,0,0,1,28.672,5.376Z"
      fill={color}
    />
  </svg>
);

Linkedin.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
};

Linkedin.defaultProps = {
  width: 28.672,
  height: 28.672,
  color: efesGrayish,
};

export default Linkedin;
